export default {
  'customerDiscountType.percentage': 'Porcentaje',
  'customerDiscountType.fixedAmount': 'Importe fijo',
  'customerDiscountFrequencyType.oneTime': 'Un período',
  'customerDiscountFrequencyType.recurring': 'Recurrente',
  'customerDiscountAssignmentStatus.scheduled': 'Programado',
  'customerDiscountAssignmentStatus.active': 'Vigente',
  'customerDiscountAssignmentStatus.exhausted': 'Agotado',
  'customerDiscountAssignmentStatus.ended': 'Terminado',
  'customerDiscountAssignmentStatus.scheduled.hint': 'Empieza en el futuro. Ocupa al cliente.',
  'customerDiscountAssignmentStatus.active.hint':
    'Puede aplicar al próximo cobro. Ocupa al cliente.',
  'customerDiscountAssignmentStatus.exhausted.hint': 'Se cumplieron los períodos. Solo historial.',
  'customerDiscountAssignmentStatus.ended.hint':
    'Lo terminó un administrador o venció el corte. Solo historial.',
  'customerDiscounts.filters.includeInactive': 'Incluir plantillas desactivadas',
  'customerDiscounts.fields.discountType': 'Tipo',
  'customerDiscounts.fields.discountValue': 'Valor',
  'customerDiscounts.fields.frequencyType': 'Frecuencia',
  'customerDiscounts.fields.durationPeriods': 'Períodos',
  'customerDiscounts.fields.durationIndefinite': 'Indefinido',
  'customerDiscounts.fields.durationHint': 'Vacío: el recurrente no tiene límite de períodos.',
  'customerDiscounts.fields.effectiveFrom': 'Disponible desde',
  'customerDiscounts.fields.effectiveTo': 'Disponible hasta',
  'customerDiscounts.fields.catalogEffectiveFrom': 'Se puede asignar desde',
  'customerDiscounts.fields.catalogEffectiveTo': 'Se puede asignar hasta',
  'customerDiscounts.fields.isActive': 'Estado',
  'customerDiscounts.fields.subscription': 'Suscripción',
  'customerDiscounts.fields.agreement': 'Plantilla activa',
  'customerDiscounts.fields.assignmentFrom': 'Aplica desde',
  'customerDiscounts.fields.assignmentTo': 'Aplica hasta',
  'customerDiscounts.fields.appliedPeriodCount': 'Períodos consumidos',
  'customerDiscounts.fields.baseNetAmount': 'Base',
  'customerDiscounts.fields.discountAmount': 'Descuento',
  'customerDiscounts.fields.netAmount': 'Neto',
  'customerDiscounts.fields.mrrAmount': 'MRR',
  'customerDiscounts.status.activeTemplate': 'Activa',
  'customerDiscounts.status.inactiveTemplate': 'Desactivada',
  'customerDiscounts.actions.assign': 'Asignar descuento',
  'customerDiscounts.actions.deactivate': 'Desactivar',
  'customerDiscounts.actions.end': 'Terminar',
  'customerDiscounts.deactivate.title': 'Desactivar plantilla',
  'customerDiscounts.deactivate.message':
    '“{name}” no admitirá asignaciones nuevas. Las asignaciones ya hechas siguen igual.',
  'customerDiscounts.assign.title': 'Asignar descuento',
  'customerDiscounts.assign.message':
    'El precio contractual no cambia. El descuento entra en el próximo período que todavía no se ha cobrado.',
  'customerDiscounts.assign.blocked':
    'Ya existe un descuento activo para esta suscripción. Termine el vigente antes de asignar otro.',
  'customerDiscounts.end.title': 'Terminar descuento',
  'customerDiscounts.end.message':
    'La asignación deja de ocupar al cliente. Un checkout de Stripe ya creado con este precio no cambia.',
  'customerDiscounts.section.title': 'Descuento del cliente',
  'customerDiscounts.section.open': 'Hay un descuento que ocupa a este cliente.',
  'customerDiscounts.section.empty': 'Este cliente no tiene un descuento abierto.',
  'customerDiscounts.section.nextCharge': 'Próximo cobro, antes de impuesto',
  'customerDiscounts.section.history': 'Historial de descuentos',
  'customerDiscounts.section.history.description':
    'Asignaciones de descuento de esta suscripción, incluidas las que ya terminaron.',
  'customerDiscounts.section.payments': 'Pagos confirmados',
  'customerDiscounts.section.payments.description':
    'Pagos confirmados. El descuento queda congelado en cada cobro y no se recalcula.',
  'customerDiscounts.payments.empty': 'No hay pagos confirmados.',
  'customerDiscounts.payments.noDiscount': 'Este cobro no tuvo descuento.',
};
